import { render } from "./LeaveAssignConfirmModal.vue?vue&type=template&id=4dec572c&scoped=true"
import script from "./LeaveAssignConfirmModal.vue?vue&type=script&lang=js"
export * from "./LeaveAssignConfirmModal.vue?vue&type=script&lang=js"

import "./LeaveAssignConfirmModal.vue?vue&type=style&index=0&id=4dec572c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dec572c"]])

export default __exports__